import React, { useRef } from 'react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';

function AnimatedStep({ stepKey, direction = 'forward', children }) {
  const nodeRef = useRef(null);
  const classNames = direction === 'backward' ? 'ob-slide-backward' : 'ob-slide-forward';

  return (
    <SwitchTransition mode="out-in">
      <CSSTransition
        key={stepKey}
        timeout={350}
        classNames={classNames}
        nodeRef={nodeRef}
      >
        <div ref={nodeRef} className="animated-step">
          {children}
        </div>
      </CSSTransition>
    </SwitchTransition>
  );
}

export default AnimatedStep;
